// refactors the result of API call to something we can use
export function parseNftObjects( nftObj, useThumbnail ) {
	return ({
		...nftObj,
		link: `https://rarible.com/token/${nftObj.contractAddress}:${nftObj.id}`,
		image: useThumbnail ? nftObj.thumbnail : nftObj.image,
	});
}

